import { render, staticRenderFns } from "./noodKenD.vue?vue&type=template&id=3c14b6ba&scoped=true"
import script from "./noodKenD.vue?vue&type=script&lang=js"
export * from "./noodKenD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14b6ba",
  null
  
)

export default component.exports